import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css } from '@bd/bdui-styles/emotion';
import { Image, GoogleMapUrl } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
// import withData from '@bd/bdcore-data';
import { colors } from '../styles';

const styles = css`
  width: 100%;
  height: 100%;
  .HomeCard_wrapper {
    display: flex;
    height: 100%;
  }
  .HomeCard_inner {
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: #F3F3F3;
  }
  .HomeCard_media {
    position: relative;
    padding: 10px;
    img {
      width: 100%;
      height: 213px;
      object-fit: cover;
    }

    .CommunityStatus {
      position: absolute;
      top: 179px;
      background-color: rgba(218, 82, 31, 0.85);
      width: calc(100% - 20px);
      height: 35px;
      color: ${colors.white};
      font-weight: 800;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 30px;
    }
  }
  .HomeCard_content {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-between;
    h4 {
      font-weight: bold;
      font-size: 26px;
      line-height: 22px;
      letter-spacing: 1px;
      background-color: #E9EAEA;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px 0 15px;
      height: 80px;
      @media(min-width: 450px) {
        padding: 0 10px 0 30px;
      }
      span {
        font-size: 15px;
        font-weight: bold;
        color: ${colors.brand1};
        letter-spacing: 1px;
        transition: all .3s ease-out;
        &:hover {
          color: ${colors.brand2};
          transition: all .3s ease-out;
        }
      }
      a {
        color: ${colors.brand1};
        transition: all .3s ease-out;
        &:hover {
          color: ${colors.brand2};
          transition: all .3s ease-out;
        }
      }
    }
    .HomeLinksWrapper {
      width: 100%;
      padding: 0 10px 0 15px;
      display: flex;
      flex-direction: column;
      @media(min-width: 450px) {
        padding: 0 10px 0 30px;
      }
      h4 {
        font-weight: 600;
        font-size: 18px;
        color: #686A6C;
        letter-spacing: 0.12px;
      }
      div {
        padding: 8px 0;
      }
      span {
        font-weight: 900;
        font-size: 18px;
        color: ${colors.brand1};
        letter-spacing: 0.34px;
        transition: all .3s ease-out;
        &:hover {
          color: ${colors.brand2};
          transition: all .3s ease-out;
        }
      }
    }
    .HomeCard_textList {
      list-style: none;
      padding: 0;
      margin: 0;
      border-bottom: 1px solid ${colors.neutral};
      flex-grow: 1;
      li {
        font-size: 13px;
        font-weight: 300;
        line-height: 1;
        border-top: 1px solid ${colors.neutral};
        padding: 10px;
        a {
          color: ${colors.brand2};
        }
      }
    }
    .HomeCard_buttonWrapper {
      display: flex;
      justify-content: flex-end;
      margin: 0;
      .HomeCard_mapButton {
        width: 40px;
        height: 40px;
        background-color: #6C6C6C;
        background-image: url('/images/icon-map-pin-white.svg');
        background-position: center center;
        background-repeat: no-repeat;
      }
      .HomeCard_detailButton {
        flex-grow: 1;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: ${colors.brand2};
        color: #FFFFFF;
        font-weight: 700;
        font-size: 15px;
      }
    }
  }
  .ViewHomeBtn {
    height: 60px;
    background-color: ${colors.brand1};
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    color: ${colors.white};
    letter-spacing: 2.7px;
    text-transform: uppercase;
    transition: all .3s ease-out;
    &:hover {
      background-color: ${colors.brand1};
      transition: all .3s ease-out;
    }
  }
  .HomeCard_mapButton {
    width: 40px;
    height: 40px;
    background-image: url('/images/icon-map-pin-mobile.svg');
    background-position: center center;
    background-repeat: no-repeat;
    cursor: pointer;
    margin-left: 12px;
  }
`;

function CommunityGridCard({ community }) {
  return (
    <div className={styles}>
      <div className="HomeCard_wrapper">
        <div className="HomeCard_inner">
          <div className="HomeCard_media">
            <Link name="community-detail" community={community}>
              {
                (get(community, 'logo.contentUrl') || get(community, 'photos[0].contentUrl')) &&
                <Image
                  className="card-img-top"
                  src={(get(community, 'logo.contentUrl') || get(community, 'photos[0].contentUrl'))}
                  alt={get(community, 'name')}
                  width={475}
                  height={315}
                  exact
                />
              }
              {
                !get(community, 'logo.contentUrl') && !get(community, 'photos[0].contentUrl') &&
                <img src="/images/coming-soon.jpg" alt="Comming Soon" />
              }
            </Link>
            {
              community.status === 'Closeout' &&
              <div className="CommunityStatus">{community.status === 'Closeout' ? 'Final Opportunities!' : ''}</div>
            }
          </div>
          <div className="HomeCard_content">
            <h4>
              <Link name="community-detail" community={community}>
                {get(community, 'name')}<br />
                <span>{get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')} {get(community, 'address.postalCode')}</span>
              </Link>
              <a href={GoogleMapUrl(community)} target="_blank" rel="noopener noreferrer">
                <div className="HomeCard_mapButton" />
              </a>
            </h4>
            <div className="HomeLinksWrapper">

              {
                get(community, 'priceLow') && get(community, 'priceHigh') &&
                <div>Price Range: <span>{numeral(get(community, 'priceLow', '')).format('$0,0')} - {numeral(get(community, 'priceHigh', '')).format('$0,0')}</span></div>
              }
              {
                get(community, 'sqftLow') && get(community, 'sqftHigh') &&
                <div>SQFT Range: <span>{numeral(get(community, 'sqftLow', '')).format('0,0')} - {numeral(get(community, 'sqftHigh', '')).format('0,0')}</span></div>
              }
              {
                get(community, 'schools[0].district') &&
                <div>School Disctrict: <span>{get(community, 'schools[0].district').replace('Independent School District', 'ISD')}</span></div>
              }

            </div>
            <Link name="community-detail" community={community} className="ViewHomeBtn">View community</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

CommunityGridCard.propTypes = {
  community: PropTypes.object.isRequired,
};

export default CommunityGridCard;



// WEBPACK FOOTER //
// ./src/components/CommunityGridCard.js